/**
 * クリック・タッチイベントの値を管理するファイル
 */

import { Vector2 } from "three";

export default {
  namespaced: true,
  state: {
    dMove: new Vector2(),
    vStart: new Vector2(),
    vMoveStart: new Vector2(),
    vMove: new Vector2(),
    vStartToMove: new Vector2(),
    vMoveToMove: new Vector2(),
    isStarted: false,
    isMoving: false,
    button: null
  },
  mutations: {
    start(state, { x, y, button }) {
      state.isStarted = true;
      state.dMove.set(x, y);
      state.vStart.set(x, y);
      state.vMove.set(x, y);
      state.button = button;
    },
    move(state, { x, y }) {
      state.dMove.set(x, y);
      state.vMoveToMove.set(x - state.vMove.x, y - state.vMove.y);
      state.vMove.set(x, y);
      if (state.isMoving === false) {
        // judge whether the touch is a swipe or a single tap.
        if (
          state.vStart
            .clone()
            .sub(state.vMove)
            .length() > 6
        ) {
          state.vMoveStart.set(x, y);
          if (state.isStarted === true) {
            state.isMoving = true;
          }
        }
      } else {
        // judge whether the swipe direction is X or Y.
        state.vStartToMove.set(
          state.vMove.x - state.vMoveStart.x,
          state.vMove.y - state.vMoveStart.y
        );
      }
    },
    end(state) {
      state.vStartToMove.set(0, 0);
      state.vMoveToMove.set(0, 0);
      state.isStarted = false;
      state.isMoving = false;
      state.button = null;
    }
  }
};
